import colorTheory from "../../translations/pl_PL/blog/colorTheory.json";
import { PUT_DATA_BLOG } from '../Blog/action';

function colorTheoryReducer(state = colorTheory, action) {
  switch (action.type) {
    case PUT_DATA_BLOG:
      {
        if (action.meta === "colorTheory") {
          return action.payload;
        } else { 
          return state }
      }

    default:
      return state;
  }
}

export default colorTheoryReducer;
